module.exports = __webpack_public_path__ + "img/event-ic-bg-pic-tips.1bff23d7.png";